module.exports = __webpack_public_path__ + "static/media/confianza_negro.76bd5619.svg";